import { AccessType } from 'app/auth/accessControlService'
import SubscriberPermission from 'app/main/subscribersV4/components/SubscriberPermission'

export const ErrorConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        leftSidePanel: {
          display: true,
        },
      },
    },
  },
  routes: [
    {
      path: '/error/permission-denied',
      component: SubscriberPermission,
      accesses: [AccessType.NOTIFICATION_VIEW_OWNED],
    },
  ],
}
